module.exports = __webpack_public_path__ + "media/slider/Banner-1-3c1f10ca.jpg";